/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import styled from 'styled-components';
import { font, colors, spacing } from '@chegg-ui/theme';
import { SecondaryLink } from '@chegg-ui/link';
export var PaginationList = styled('ul').withConfig({
  componentId: "e90xpl-0"
})(["display:inline-flex;flex-direction:row;margin-block-start:0;margin-block-end:0;padding-inline-start:0;font-family:", ";"], font.family["default"]);
export var PaginationListItem = styled('li').withConfig({
  componentId: "e90xpl-1"
})(["font-size:", ";width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;list-style-type:none;margin:0 ", ";border:2px solid ", ";border-radius:1.5rem;&:hover{border:2px solid ", ";}&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}", " ", ""], font.size.lg, spacing.xxs, colors.transparent, colors.cheggOrange, function (_ref) {
  var isHidden = _ref.isHidden;
  return isHidden ? 'visibility: hidden;' : '';
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? "border: 2px solid ".concat(colors.cheggOrange, ";") : '';
});
export var PaginationControl = styled(PaginationListItem).withConfig({
  componentId: "e90xpl-2"
})(["font-size:", ";width:4.75rem;& svg{margin:0 ", ";}&:first-of-type{& svg{margin-left:0;}}&:last-of-type{& svg{margin-right:0;}}"], font.size.md, spacing.xxs);
export var PaginationLink = styled(SecondaryLink).withConfig({
  componentId: "e90xpl-3"
})(["font-size:inherit;font-weight:", ";display:flex;flex:1;justify-content:center;align-items:center;height:2.25rem;&:hover,&:focus,&:active{text-decoration:none;}"], font.weight.bold);
export var PlaceholderListItem = styled(PaginationListItem).withConfig({
  componentId: "e90xpl-4"
})(["border:2px solid ", ";&:hover{border:2px solid ", ";}"], colors.transparent, colors.transparent);
export var PlaceholderSpan = styled.span.withConfig({
  componentId: "e90xpl-5"
})(["text-indent:3px;letter-spacing:3px;font-size:", ";font-family:", ";font-weight:", ";color:", ";height:30px;line-height:1.25rem;pointer-events:none;"], font.size.md, font.family["default"], font.weight.bold, colors.dark);